import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaSearch } from "react-icons/fa";

export default function PageHeader({ title, search, setSearch }) {
  const navigate = useNavigate();

  return (
    <div className="mb-14">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div>
          <button
            onClick={() => navigate(-1)}
            aria-label="Go back"
            className="flex items-center gap-2 text-sm text-blue-600
                       font-semibold hover:underline mb-2 transition duration-200 ease-in-out transform hover:scale-105"
          >
            <FaArrowLeft className="text-xs" />
            Back
          </button>

          <h1 className="text-4xl font-bold text-gray-900 tracking-tight">
            {title}
          </h1>
        </div>

        <div className="relative w-full sm:w-[360px]">
          <FaSearch
            className="absolute left-4 top-1/2 -translate-y-1/2
                       text-gray-400 text-sm"
          />

          <input
            type="text"
            placeholder={`Search ${title.toLowerCase()}...`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-11 pr-4 py-3.5 rounded-xl border
                       bg-white text-sm shadow-sm
                       focus:outline-none focus:ring-2
                       focus:ring-blue-500 transition"
          />
        </div>
      </div>
    </div>
  );
}
